import { useQueryClient } from '@tanstack/react-query';
import FolderExplorer from '../documents/FolderExplorer';

/**
 * The customer's documents from the central document system, as a file
 * explorer limited to this customer's folders (P-40, D-207 Q-189): classification
 * and portal-publication badges, the shared detail drawer, upload to the open folder.
 * W-09: no extra header (the tab name is enough) and one toolbar inside the explorer.
 */
export default function DocumentsTab({
  orgId,
  canWrite,
}: {
  orgId: string;
  canWrite: boolean;
}) {
  const queryClient = useQueryClient();

  return (
    <section className="min-w-0">
      <FolderExplorer
        mode="customer"
        organizationId={orgId}
        canWrite={canWrite}
        screenHref={`/documents?org=${orgId}`}
        onChanged={() => queryClient.invalidateQueries({ queryKey: ['customer-hub-summary', orgId] })}
      />
    </section>
  );
}
